var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1044_8408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29726 0.561683C2.90054 0.956915 2.90054 1.59771 3.29726 1.99295L9.69004 8.3617L3.29726 14.7305C2.90054 15.1257 2.90054 15.7665 3.29726 16.1617C3.69399 16.557 4.3372 16.557 4.73392 16.1617L11.845 9.07734C12.2418 8.6821 12.2418 8.0413 11.845 7.64607L4.73392 0.561683C4.3372 0.166451 3.69399 0.166451 3.29726 0.561683Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1044_8408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.1929,
    fill: "white",
    transform: "translate(0 0.265259)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.1eb67d9f14cfb89133dc1ea88b8085f9.svg";
export { ForwardRef as ReactComponent };